import MEWPClass from './mew-provider-class';
import { OCTIUM } from '@/utils/networks/types';
class ParaSwap {
  constructor(web3, chain) {
    return new MEWPClass(
      MEWPClass.supportedDexes.PARASWAP,
      web3,
      [OCTIUM.name],
      chain
    );
  }
}
export default ParaSwap;
